import { render, staticRenderFns } from "./LiquidacionDetalleTable.vue?vue&type=template&id=c5636b76"
import script from "./LiquidacionDetalleTable.vue?vue&type=script&lang=js"
export * from "./LiquidacionDetalleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports